import { Component } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';

/**
 * Dialog da Política de Privacidade. O `<iframe>` com o PDF só existe quando o dialog
 * é aberto (no site antigo ele era carregado em todas as páginas).
 */
@Component({
  selector: 'app-privacy-policy-dialog',
  imports: [MatDialogTitle, MatDialogContent, MatDialogClose, MatIconButton],
  templateUrl: './privacy-policy-dialog.html',
  styleUrl: './privacy-policy-dialog.scss',
})
export class PrivacyPolicyDialog {}
